
import { HttpClient, HttpRequest, HttpEventType, HttpResponse } from '@angular/common/http';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, HostListener } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { UploadEvent, UploadFile, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { Observable } from 'rxjs/Observable';
import { FileUploadModel } from 'app/shared/models/file-upload.model';
import { NgxDropzoneChangeEvent } from 'ngx-dropzone';
import { EnrollmentProgramsService } from 'app/shared/services/enrollment-programs.service';
import { SecurityService } from 'app/security/security.service';
import { AppSettings } from 'app/shared/app-settings';
import { ToastsManager } from 'ng2-toastr';
import { Router } from '@angular/router';


@Component({
  selector: 'online-app-student-file-uploads',
  templateUrl: './student-file-uploads.component.html',
  styleUrls: ['./student-file-uploads.component.scss']
})
export class StudentFileUploadComponents implements OnInit{

  programAlias: string = "";
  fileUploadMsg: string = "";
  files: File[] = [];
  lockUploadZone: boolean = false;
  progress: number;
  message:string;
  docTypes: IDocType[];
  requestedDocs: IDocumentRequest[];
  nonVerifiedRequests: IDocumentRequest[];
  allowMultiple: boolean = false;
  providerAccess: boolean = false;

  selectedDocType: Number = 0;

  constructor(private http: HttpClient,
    private router: Router,
    private snackbar: MatSnackBar,
    public toastr: ToastsManager,
    private programsService: EnrollmentProgramsService,
    private securityService: SecurityService
    ) { }

 protected get FileUploadMessage(): Observable<string>{
    return this.programsService.getFileUploadMessage();
  }

  ngOnInit() {

    this.getDocumentRequested();
    this.programAlias = this.securityService.currentUserInfo.enrollmentProgramAlias;
    this.providerAccess = sessionStorage.getItem('isProviderAccess') != null &&  sessionStorage.getItem('isProviderAccess') == 'true';
    this.programsService.getProgramStatements(this.programAlias);
  }


  getDocumentRequested(){
    var isProv = sessionStorage.getItem('isProviderAccess') != null &&  sessionStorage.getItem('isProviderAccess') == 'true';
    this.securityService.currentUserInfo.isProvider = isProv;
    
    this.http.get(AppSettings.formatUrl(AppSettings.endpoints.enrollees.documentRequest, this.securityService.currentUserInfo.isProvider )).subscribe( data =>{
      //console.log('requested doc types result -> ', data);
       this.requestedDocs = data as IDocumentRequest[];
       this.nonVerifiedRequests = this.requestedDocs.filter((val) => !val.verified);
       //console.log('test', this.nonVerifiedRequests);
     });
  }

	onSelect(event: NgxDropzoneChangeEvent ) {
    //console.log(event);
    if(this.files.length > 0 && !this.allowMultiple){
      this.files = [];
    }

		this.files.push(...event.addedFiles);
	}

	onRemove(event) {
		//console.log(event);
		this.files.splice(this.files.indexOf(event), 1);
  }

  changeDocumentType(e) {
    this.files = [];
    //console.log(e.target.value);

    var result = this.nonVerifiedRequests.find( val => val.allowMultiple && val.requestedDocumentTypeId == e.target.value);

    this.lockUploadZone = e.target.value != 0 || e.target.value != null;
    this.allowMultiple = result ? result.allowMultiple : false;
  }

  uploadFile(){
    if (this.files.length === 0 || this.selectedDocType === 0)
      return;

    let formData = new FormData();
    formData.append("DocTypeId", this.selectedDocType.toString());

    for (let i = 0; i < this.files.length; i++) {
      formData.append(`Doc${i}`, this.files[i]);
    }

    const uploadReq = new HttpRequest('POST', AppSettings.endpoints.enrollees.studentDocumentUpload, formData, {
      reportProgress: true
    });

    this.http.request(uploadReq).subscribe( event => {
      if ( event.type === HttpEventType.UploadProgress){
        this.progress = Math.round( 100 * event.loaded / event.total);
      }
      else if (event.type === HttpEventType.Response){
          this.getDocumentRequested();
          this.message = event.body.toString();
          this.toastr.success('Successfully Uploaded','Success');
      }
      this.files = [];
      this.selectedDocType = 0;
      this.lockUploadZone = false;
    },

      (error) => {
        this.toastr.error('Failed to upload. Please try again');
        this.files = [];
        this.selectedDocType = 0;
        this.lockUploadZone = false;
      }
    );
  }
}

interface IDocType {
  id: Number;
  name: string;
}

interface IDocumentRequest {
  requestedDocumentTypeId: number;
  requestedDocumentTypeName: string;
  submitted: boolean;
  dateRequested: Date;
  allowMultiple: boolean;
  verified: boolean;
  rejected: boolean;
}



// WEBPACK FOOTER //
// ./src/app/additional-resources/student-file-uploads/student-file-uploads.component.ts